var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVitaeProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20.4674 11.25C20.1669 7.81282 17.8206 4.96205 14.6533 3.9223C15.6877 5.60305 16.3871 8.24126 16.4875 11.25H20.4674ZM20.4674 12.75C20.1669 16.1872 17.8206 19.0379 14.6533 20.0777C15.6877 18.397 16.3871 15.7587 16.4875 12.75H20.4674ZM14.9867 11.25C14.9049 8.9629 14.4538 6.96606 13.8141 5.54448C13.042 3.82873 12.2847 3.5 12 3.5C11.7153 3.5 10.958 3.82873 10.1859 5.54448C9.54619 6.96606 9.09513 8.9629 9.01335 11.25H14.9867ZM9.01335 12.75H14.9867C14.9049 15.0371 14.4538 17.0339 13.8141 18.4555C13.042 20.1713 12.2847 20.5 12 20.5C11.7153 20.5 10.958 20.1713 10.1859 18.4555C9.54619 17.0339 9.09513 15.0371 9.01335 12.75ZM7.51247 11.25C7.61285 8.24126 8.31232 5.60305 9.34674 3.9223C6.17936 4.96205 3.83313 7.81282 3.53263 11.25H7.51247ZM3.53263 12.75H7.51247C7.61285 15.7587 8.31232 18.397 9.34674 20.0777C6.17936 19.0379 3.83313 16.1872 3.53263 12.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaeProfile);
export default __webpack_public_path__ + "static/media/vitae-profile.e35fe9e5.svg";
export { ForwardRef as ReactComponent };